import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DatabaseService } from '../../../database/database.service';
import { BackgroundSyncService } from '../../../helpers/backgroundSync.service';
import { ShowExamnsTemplateContainerService } from '../../forms/show-examns-template-container/show-examns-template-container.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { EditExamenTemplateContainerService } from '../../forms/edit-examen-template-container/edit-examen-template-container.service';
import { AttachUploadFileService } from '../attach-upload-file/attach-upload-file.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-examens-cargados-card-item',
  templateUrl: './examens-cargados-card-item.component.html',
  styleUrls: ['./examens-cargados-card-item.component.scss']
})
export class ExamensCargadosCardItemComponent implements OnInit {
  @Input() card: any;
  @Input() isLastCardItem: boolean;
  id: number;
  codigoTipoExamen = '';
  isOnline = true;

  constructor(
    private router: Router,
    private databaseService: DatabaseService,
    private backgroundSyncService: BackgroundSyncService,
    private connectionService: ConnectionService,
    private showExamnsTemplateService: ShowExamnsTemplateContainerService,
    private editExamenTemplateService: EditExamenTemplateContainerService,
    private attachUploadFileService: AttachUploadFileService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.card.categoriaExamen = 'cargados';
    this.card.isEditable = false;
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));

    if (this.card.cargadoEnAdjunto && this.isOnline) {
      if (this.card.attachments && this.card.attachments.length >0){
        this._getAttachedItemFromApi(this.card.attachments[0]);
      }
    }
    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      this.isOnline = connected.hasNetworkConnection;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      this.isOnline = connected.hasNetworkConnection;
    })
  }

  editExam(cardItem: any) {
    console.log('deberia redireccionarme a la vista de EDITAR')
        // console.log('deberia redirigirme a la vista de VER examen cargado basado en esta data', cardItem);

    /**
     * * esta linea en particular es para setear desde donde vengo
     * * para que cuando le de acia atras vuelva a la misma pestaña
     * ? localStorage.setItem( 'tab', this.card.categoriaExamen );
     */
     localStorage.setItem('tab', this.card.categoriaExamen);

     /**
      * ! UNO
      * * por lo que sugiere la funcion de abajo, yo tendria que
      * * crear un servicio donde se cargue maneje y persita (temporalmente) la data del examen que estoy viendo
      * * tal vez ahi mismo estaria la llamada a cada tipo de examen
      * ? this.examFormService.updateDataExam(this.card);
      */

     if (this.isOnline || cardItem.examenDataToSend.cargadoOffline) {

       if (cardItem.examenDataToSend) {
         cardItem.isExamenPorEnviar = true;
         cardItem.categoriaExamen = 'cargados';
         cardItem.isEditable = false;
         this.codigoTipoExamen = cardItem.examenData.tipoEstudio.tipoEstudioCod
                  ? cardItem.examenData.tipoEstudio.tipoEstudioCod
                  : cardItem.examenDataToSend.tipoEstudio;
         this.id  = cardItem.examenData.id;

         this.editExamenTemplateService.updateDataExam(cardItem);
       } else {
         cardItem.isExamenPorEnviar = false;
         this.codigoTipoExamen = this.card.tipoEstudio.tipoEstudioCod;
         this.id  = this.card.id;

         this.editExamenTemplateService.updateDataExam(cardItem);
       }



       /**
        * ! DOS
        * * tengo que crear la URL a la cual se redijiria para ver
        * * y con eso alimentar al el ruter para que me envie a esa vista
        * * entonces al cargar esa nueva vista segun el tipo de examen y el ID  pedir la data de ese examen especifico
        * ? this.router.navigate([`examen/${categoriaExamen}/${tipoExamen}/${codigoTipoExamen}/${id}`]);
        */

       let url = `editar/examen/${this.codigoTipoExamen}/${this.id}`;

       this.router.navigate([url]);
     }

  }

  showExam(cardItem: any): void {

    // console.log('deberia redirigirme a la vista de VER examen cargado basado en esta data', cardItem);

    /**
     * * esta linea en particular es para setear desde donde vengo
     * * para que cuando le de acia atras vuelva a la misma pestaña
     * ? localStorage.setItem( 'tab', this.card.categoriaExamen );
     */
    localStorage.setItem('tab', this.card.categoriaExamen);

    /**
     * ! UNO
     * * por lo que sugiere la funcion de abajo, yo tendria que
     * * crear un servicio donde se cargue maneje y persita (temporalmente) la data del examen que estoy viendo
     * * tal vez ahi mismo estaria la llamada a cada tipo de examen
     * ? this.examFormService.updateDataExam(this.card);
     */

    if (cardItem.examenDataToSend) {
      cardItem.isExamenPorEnviar = true;
      cardItem.categoriaExamen = 'cargados';
      cardItem.isEditable = false;
      this.codigoTipoExamen = cardItem.examenData.tipoEstudio.tipoEstudioCod
                    ? cardItem.examenData.tipoEstudio.tipoEstudioCod
                    : cardItem.examenData.tipoEstudio;
      this.id  = cardItem.examenData.id;

      this.showExamnsTemplateService.updateDataExam(cardItem);
    } else {
      cardItem.isExamenPorEnviar = false;
      this.codigoTipoExamen = this.card.tipoEstudio.tipoEstudioCod;
      this.id  = this.card.id;

      this.showExamnsTemplateService.updateDataExam(cardItem);
    }



    /**
     * ! DOS
     * * tengo que crear la URL a la cual se redijiria para ver
     * * y con eso alimentar al el ruter para que me envie a esa vista
     * * entonces al cargar esa nueva vista segun el tipo de examen y el ID  pedir la data de ese examen especifico
     * ? this.router.navigate([`examen/${categoriaExamen}/${tipoExamen}/${codigoTipoExamen}/${id}`]);
     */

    let url = `ver/examen/${this.codigoTipoExamen}/${this.id}`;

    this.router.navigate([url]);
  }

  _getAttachedItemFromApi(item){

    if (item.nombreRepositorio) {
      item.loadTime = parseInt(item.nombreRepositorio.replace(/[A-Za-z]/g, ''));
    }

    (item.nombreOriginal) ? item.name = item.nombreOriginal : item.name;

    // Me traigo el archivo lo combierto en base 64 y se lo pego al link
    this.attachUploadFileService.getAttachedFileFromApi({
      idAsociado: this.card.id,
      nombreRepositorio: item.nombreRepositorio,
      isExamen: true
    }).subscribe(data => {
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        let img: any = reader.result;
        item.archivoBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(img);
      }, false);

      if (data) {
        reader.readAsDataURL(data);
      }
    }, error => {
      console.log(error);
    });
  }

}
